import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import VerifyPhoneForm from '../../components/Form/VerifyPhoneForm/VerifyPhoneForm'
import { userActions } from '../../redux/actions'
import { currentUser } from '../../redux/reducers/user.reducers'

class VerifyPhone extends React.Component {
  componentDidMount() {
    this.redirectIfPhoneVerified()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.user.phoneVerified !== this.props.user.phoneVerified) {
      this.redirectIfPhoneVerified()
    }
  }

  _handleSubmit = values => {
    const { user, verifyPhoneNumber, history } = this.props

    const mergedValues = {
      code: values.validationCode,
      // eslint-disable-next-line camelcase
      user_id: user.id,
    }
    // TODO: Make protected route
    return verifyPhoneNumber(mergedValues).then(() => {
      history.push('/claim-reward')
    })
  }

  redirectIfPhoneVerified = () => {
    const { history, user } = this.props

    if (user.phoneVerified) {
      history.push('/claim-reward')
    }
  }

  render() {
    const { intl } = this.props
    const label = intl.formatMessage({ id: 'global.label.verifyPhone' })

    return (
      <div className="reset-password-page" role="main" aria-label="Verify Phone Main">
        <Helmet>
          <title>{label}</title>
          <meta name="description" content="your description" />
        </Helmet>
        <div className="container mt-5 mb-5">
          <h1 className="page-title">
            <FormattedMessage id="global.label.verifyPhone" />
          </h1>
          <div className="row justify-content-center">
            <div className="col-md-8 col-xl-6">
              <VerifyPhoneForm onSubmit={this._handleSubmit} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({ user: currentUser(state) })

const mapDispatchToProps = dispatch => ({
  verifyPhoneNumber: (...args) => dispatch(userActions.verifyPhoneNumber(...args)),
})

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(VerifyPhone)))
